/**
 * useDailyCheckin - Daily check-in form state & side effects
 * Extracted from App.js Phase 5 refactoring
 * 
 * Note: submitDailyCheckin remains in App.js due to cross-dependencies
 * (loadAiMiq, loadHydrationStatus, showCoachToast, etc.)
 */
import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const useDailyCheckin = ({ userId, useImperial, todayExercises }) => {
  const [showDailyCheckin, setShowDailyCheckin] = useState(false);
  const [dailyCheckinData, setDailyCheckinData] = useState(null);
  const [dailyCheckinLoading, setDailyCheckinLoading] = useState(false);
  const [checkedInToday, setCheckedInToday] = useState(false);
  const [dailyCheckinContribution, setDailyCheckinContribution] = useState(null);
  const [checkinFormData, setCheckinFormData] = useState({
    sleep_quality: 3,
    stress_level: 3,
    activity_level: 3,
    notes: '',
    sleep_hours: '',
    sleep_mins: '',
    sleep_source: 'self_report',
    steps_count: '',
    steps_source: 'self_report',
    weight: '',
    weight_unit: 'kg',
    hydration_ml: 0
  });
  const [weightCheckStatus, setWeightCheckStatus] = useState(null);

  // Fetch weight check-in status when modal opens
  useEffect(() => {
    if (showDailyCheckin && userId) {
      fetch(`${BACKEND_URL}/api/ai-miq/daily-checkin/${userId}/weight-status`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setWeightCheckStatus(data);
            if (data.weight_unit) {
              setCheckinFormData(prev => ({ ...prev, weight_unit: data.weight_unit }));
            } else if (useImperial) {
              setCheckinFormData(prev => ({ ...prev, weight_unit: 'lbs' }));
            }
          }
        })
        .catch(err => console.error('Error fetching weight status:', err));
    }
  }, [showDailyCheckin, userId, useImperial]);

  // Sync steps from Activity section to check-in form when modal opens
  useEffect(() => {
    if (showDailyCheckin && todayExercises) {
      const todayStepsEntry = todayExercises.find(ex => ex.activity === 'Walking (Steps)');
      const actualTodaySteps = todayStepsEntry?.steps || 0;
      setCheckinFormData(prev => ({
        ...prev,
        steps_count: actualTodaySteps > 0 ? actualTodaySteps.toString() : ''
      }));
    }
  }, [showDailyCheckin, todayExercises]);

  return {
    showDailyCheckin, setShowDailyCheckin,
    dailyCheckinData, setDailyCheckinData,
    dailyCheckinLoading, setDailyCheckinLoading,
    checkedInToday, setCheckedInToday,
    dailyCheckinContribution, setDailyCheckinContribution,
    checkinFormData, setCheckinFormData,
    weightCheckStatus, setWeightCheckStatus
  };
};

export default useDailyCheckin;
